export default __webpack_public_path__ + "b1d9d9904bfca8802a631c45590b9efa.woff";